import { useHistory } from 'react-router'
import { ReauthenticationVariant } from 'shared/types'
import {
  exitSystemAdminMode,
  getReauthenticationSuccessPath,
  isSystemAdminMode,
  takeSessionExtensionReturnPath,
} from 'shared/utils'

// Reauthentication ends the system admin mode, except for the session extension,
// which goes back to the page it was started from in the same mode
export const useRedirectToReauthenticationSuccess = () => {
  const history = useHistory()

  return (variant: ReauthenticationVariant) => {
    if (variant === ReauthenticationVariant.EXTEND_SESSION) {
      history.replace(takeSessionExtensionReturnPath())
      return
    }

    const successPath = getReauthenticationSuccessPath(variant)

    if (isSystemAdminMode()) {
      exitSystemAdminMode(successPath)
    } else {
      history.push(successPath)
    }
  }
}
